import Box from '@material-ui/core/Box';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grid from '@material-ui/core/Grid';
import IconButton from '@material-ui/core/IconButton';
import LinearProgress from '@material-ui/core/LinearProgress';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import InsertDriveFileIcon from '@material-ui/icons/InsertDriveFile';
import InsertEmoticonIcon from '@material-ui/icons/InsertEmoticon';
import SendIcon from '@material-ui/icons/Send';
import { withStyles } from '@material-ui/styles';
import axios from 'axios';
import { Picker } from 'emoji-mart';
import 'emoji-mart/css/emoji-mart.css';
import React, { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { sendMessageAction } from 'store/message/messageActions';
import { getPresignedMessageFileBucketUrl } from 'utils/apiCalls';

const ChatInputBox = withStyles(() => ({
  input: {
    height: 10,
  },
}))(OutlinedInput);

export default function ChatInput() {
  const dispatch = useDispatch();
  const { meetingId, attendeeId, externalUserId, externalMeetingId, name } = useSelector(
    ({ chime }) => ({
      meetingId: chime.meetingId,
      attendeeId: chime.meetingId,
      externalUserId: chime.externalUserId,
      externalMeetingId: chime.externalMeetingId,
      name: chime.name,
    })
  );
  const [inputText, setInputText] = useState('');
  const [showEmotiPicker, setShowEmotiPicker] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  // const inputFileContent = useRef(null);
  const [isUploadingFile, setIsUploadingFile] = useState({
    percentCompleted: 0,
    isUploading: false,
  });

  const send = async () => {
    const message = inputText?.trim();
    if ((message || selectedFile) && meetingId && attendeeId) {
      let payload = {
        attendeeId,
        ExternalUserId: externalUserId,
        meetingId,
        name,
      };
      if (message) payload = { ...payload, message };
      if (selectedFile) {
        setIsUploadingFile({ percentCompleted: 0, isUploading: true });
        const fileResp = await getPresignedMessageFileBucketUrl(
          externalMeetingId,
          meetingId,
          externalUserId,
          selectedFile.type,
          selectedFile.name
        );
        const config = {
          onUploadProgress: function (progressEvent) {
            const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
            setIsUploadingFile({ isUploading: true, percentCompleted });
          },
          headers: {
            'Content-Type': selectedFile.type,
          },
        };

        try {
          await axios.put(fileResp.url, selectedFile, config);
          setIsUploadingFile({ percentCompleted: 100, isUploading: false });
        } catch (err) {
          setIsUploadingFile({ percentCompleted: 100, isUploading: false });
        }

        payload = {
          ...payload,
          file: true,
          fileId: fileResp.fileId,
          fileName: selectedFile.name,
        };
      }
      dispatch(
        sendMessageAction({
          type: 'chat-message',
          payload: {
            payload,
            externalMeetingId,
            meetingId,
          },
        })
      );
      setInputText('');
      setSelectedFile(null);
    }
  };

  // const onFileChange = (event) => {
  //   const file = event?.target?.files?.[0];
  //   if (file) {
  //     setSelectedFile(file);
  //   }
  // };

  return (
    <>
      {showEmotiPicker && (
        <ClickAwayListener onClickAway={() => setShowEmotiPicker(false)}>
          <Picker
            style={{ position: 'absolute', bottom: 65, right: 60, zIndex: 5 }}
            emoji="point_up"
            onSelect={(emoji) => {
              setInputText(`${inputText}${emoji.native} `);
              setShowEmotiPicker(false);
            }}
          />
        </ClickAwayListener>
      )}

      <Grid container justify="center">
        <Grid item xs={11} style={{ marginBottom: 5 }}>
          {selectedFile && (
            <>
              <Box display="flex" justifyContent="flex-start" alignItems="flex-end">
                <Box>
                  <InsertDriveFileIcon />
                </Box>
                <Box>{selectedFile?.name}</Box>
              </Box>
              {isUploadingFile.isUploading && (
                <Box display="flex" alignItems="center">
                  <Box width="100%" mr={1}>
                    <LinearProgress
                      color="primary"
                      variant="determinate"
                      value={isUploadingFile.percentCompleted}
                    />
                  </Box>
                </Box>
              )}
            </>
          )}
          <ChatInputBox
            fullWidth
            value={inputText}
            data-testid="themsg"
            onChange={(event) => {
              setInputText(event.target.value);
            }}
            onKeyUp={(event) => {
              event.preventDefault();
              if (event.keyCode === 13) send();
            }}
            placeholder="Enter Message"
          />
        </Grid>

        <Grid item xs={12}>
          <Box display="flex" flexGrow={1} flexDirection="row" justifyContent="space-between">
            <Box display="flex">
              <IconButton size="small" onClick={() => setShowEmotiPicker(!showEmotiPicker)}>
                <InsertEmoticonIcon />
              </IconButton>

              {/* <input
                ref={inputFileContent}
                type="file"
                onChange={onFileChange}
                style={{ display: 'none' }}
              />
              <IconButton size="small" onClick={() => inputFileContent.current.click()}>
                <AttachFileIcon />
              </IconButton> */}
            </Box>
            <Box display="flex">
              <IconButton size="small" data-testid="send" onClick={send}>
                <SendIcon />
              </IconButton>
            </Box>
          </Box>
        </Grid>
      </Grid>
    </>
  );
}
